import { CheckboxField } from '@/types/forms/fields/checkboxField';
import { FormList } from '@/types/forms/fields/formList';
import { RadioButtonsField } from '@/types/forms/fields/radioButtonsField';
import { TextField } from '@/types/forms/fields/textField';
import { FormElement } from '@/types/forms/formElement';
import { FormOption } from '@/types/forms/formOption';
import { ControllableConsumptionDevicesFormStep } from '@/types/forms/formSteps/controllableConsumptionDevicesFormStep';
import { checked } from '@/validators/checked';
import { float } from '@/validators/float';
import { gt } from '@/validators/gt';
import { positive } from '@/validators/positive';
import { registeredConsumptionDeviceIdentificationNumber } from '@/validators/registeredConsumptionDeviceIdentificationNumber';
import { registeredConsumptionDeviceIdentificationNumbers } from '@/validators/registeredConsumptionDeviceIdentificationNumbers';
import { required } from 'vuelidate/lib/validators';

export const controllableConsumptionDevicesFormStep = new ControllableConsumptionDevicesFormStep(
    {
        controllableConsumptionDevicesInfo: new FormElement(),
        gridControlConditionsAccepted: new CheckboxField({
            validators: {
                checked,
            },
        }),
        gridControlImplementationPreference: new RadioButtonsField({
            value: 'directControl',
            options: [
                new FormOption({ key: 'directControl' }),
                new FormOption({ key: 'indirectLoadMgmt' }),
            ],
            validators: {
                required,
            },
        }),
        connectionTypeSelector: new RadioButtonsField({
            value: 'relayContacts',
            options: [
                new FormOption({ key: 'relayContacts' }),
                new FormOption({ key: 'digitalInterfaceEEBUS' }),
            ],
            validators: {
                required,
            },
        }),
        maxConnectionLoad: new TextField({
            value: '',
            validators: {
                required,
                float,
                positive,
                gt: gt(0),
            },
        }),
        identificationNumbersOfRegisteredConsumptionDevices: new FormList(
            TextField,
            {
                initializeItems: 1,
                minItemCount: 0,
                maxItemCount: 8,
                validators: {
                    registeredConsumptionDeviceIdentificationNumber,
                    registeredConsumptionDeviceIdentificationNumbers,
                },
            },
        ),
        controllableConsumptionFacilitiesRequirementInfo: new FormElement(),
    },
);
